// extracted by mini-css-extract-plugin
module.exports = {"root":"container_root__3nutI","sm":"container_sm__2_UeD","md":"container_md__JQ7Si","lg":"container_lg__3q14u","xl":"container_xl__1Wrda","2xl":"container_2xl__2m_bt"};